import styled from 'styled-components';
import { hexToRGB } from '@app/utils/utils';

/**
 * Shared header row for list pages: title hard left, controls flush right.
 *
 * AntD's own small/default control sizes read thin against the 14px tables
 * these sit above, so every control is pinned to one height here. Doing it in
 * one place keeps search boxes and buttons the same size on every page.
 */
export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding-bottom: 14px;

  && .ant-btn,
  && .ant-input-affix-wrapper,
  && .ant-input,
  && .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    height: 42px;
    font-size: 14px;
  }

  /* The inner input of an affix wrapper must not also be fixed height, or the
     text and clear icon sit off-centre. */
  && .ant-input-affix-wrapper > .ant-input {
    height: auto;
  }

  && .ant-select-single .ant-select-selector .ant-select-selection-item,
  && .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    line-height: 40px;
  }

  && .ant-input::placeholder {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.text.light};
  }
`;

/** Search, filters and actions, pushed to the right of the title. */
export const ToolbarActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-wrap: wrap;
`;

export const PageTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.01em;
  white-space: nowrap;
`;

/** "1,234 orders · page 2" line between the toolbar and the table. */
export const ResultCount = styled.div`
  font-variant-numeric: tabular-nums;
  font-size: 14px;
  color: ${({ theme }) => hexToRGB(theme.colors.text.main, 0.45)};
  margin-bottom: 10px;
`;
